module.exports = __webpack_public_path__ + "static/media/aptoMedicoDesafio.f1974849.pdf";